"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowMore = void 0;
exports.hasShowMore = hasShowMore;
var config_1 = require("../config");
var get_closest_1 = require("../helper/get-closest");
var ShowMore = /*#__PURE__*/function () {
  function ShowMore() {
    var _this = this;
    _classCallCheck(this, ShowMore);
    this.showMoreToggles = null;
    this.showMoreToggles = document.querySelectorAll(config_1.CONFIG.showMore.toggle);
    if (this.showMoreToggles.length > 0) {
      [].forEach.call(this.showMoreToggles, function (showMoreToggle) {
        showMoreToggle.addEventListener('click', _this.toggleShowMore.bind(_this));
      });
    }
  }
  return _createClass(ShowMore, [{
    key: "toggleShowMore",
    value: function toggleShowMore(event) {
      event.preventDefault();
      var container = (0, get_closest_1.getClosest)(config_1.CONFIG.showMore.main, event.target);
      var trigger = (0, get_closest_1.getClosest)(config_1.CONFIG.showMore.toggle, event.target);
      container.classList.toggle(config_1.CONFIG.showMore.visibleClass);
      if (container.classList.contains(config_1.CONFIG.showMore.visibleClass)) {
        trigger.innerHTML = 'Show less';
      } else {
        trigger.innerHTML = 'Show more';
      }
    }
  }]);
}();
exports.ShowMore = ShowMore;
function hasShowMore() {
  if (document.querySelectorAll(config_1.CONFIG.showMore.toggle).length > 0) {
    return true;
  }
  return false;
}